/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { GroupsControllerGetDocumentEffectivePrecedenceOrdersQueryResponse, GroupsControllerGetDocumentEffectivePrecedenceOrdersPathParams, GroupsControllerGetDocumentEffectivePrecedenceOrdersQueryParams, GroupsControllerGetDocumentEffectivePrecedenceOrders401, GroupsControllerGetDocumentEffectivePrecedenceOrders403, GroupsControllerGetDocumentEffectivePrecedenceOrders404 } from "../../models/documentGroupsController/GroupsControllerGetDocumentEffectivePrecedenceOrders";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { groupsControllerGetDocumentEffectivePrecedenceOrders } from "../../clients/document-groupsService/groupsControllerGetDocumentEffectivePrecedenceOrders";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const groupsControllerGetDocumentEffectivePrecedenceOrdersQueryKey = (documentId: GroupsControllerGetDocumentEffectivePrecedenceOrdersPathParams["documentId"], params: GroupsControllerGetDocumentEffectivePrecedenceOrdersQueryParams = {}) => [{
  url: '/api/v1/documents/groups/documents/:documentId/effective-precedence-orders',
  params: {
    documentId: documentId
  }
}, ...(params ? [params] : [])] as const;
export type GroupsControllerGetDocumentEffectivePrecedenceOrdersQueryKey = ReturnType<typeof groupsControllerGetDocumentEffectivePrecedenceOrdersQueryKey>;
export function groupsControllerGetDocumentEffectivePrecedenceOrdersQueryOptions(documentId: GroupsControllerGetDocumentEffectivePrecedenceOrdersPathParams["documentId"], params?: GroupsControllerGetDocumentEffectivePrecedenceOrdersQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = groupsControllerGetDocumentEffectivePrecedenceOrdersQueryKey(documentId, params);
  return queryOptions<GroupsControllerGetDocumentEffectivePrecedenceOrdersQueryResponse, ResponseErrorConfig<GroupsControllerGetDocumentEffectivePrecedenceOrders401 | GroupsControllerGetDocumentEffectivePrecedenceOrders403 | GroupsControllerGetDocumentEffectivePrecedenceOrders404>, GroupsControllerGetDocumentEffectivePrecedenceOrdersQueryResponse, typeof queryKey>({
    enabled: !!documentId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return groupsControllerGetDocumentEffectivePrecedenceOrders(documentId, params, config);
    }
  });
}

/**
 * @description Resolves the enclosing project's chains exactly as the project read does and returns those containing the document — as a governing document or as a member of a linking group. A document in no chain, or a VERSIONED/DELETED document, returns an empty collection.
 * @summary Derive the effective order(s) of precedence for the chain a document belongs to
 * {@link /api/v1/documents/groups/documents/:documentId/effective-precedence-orders}
 */
export function useGroupsControllerGetDocumentEffectivePrecedenceOrders<TData = GroupsControllerGetDocumentEffectivePrecedenceOrdersQueryResponse, TQueryData = GroupsControllerGetDocumentEffectivePrecedenceOrdersQueryResponse, TQueryKey extends QueryKey = GroupsControllerGetDocumentEffectivePrecedenceOrdersQueryKey>(documentId: GroupsControllerGetDocumentEffectivePrecedenceOrdersPathParams["documentId"], params?: GroupsControllerGetDocumentEffectivePrecedenceOrdersQueryParams, options: {
  query?: Partial<QueryObserverOptions<GroupsControllerGetDocumentEffectivePrecedenceOrdersQueryResponse, ResponseErrorConfig<GroupsControllerGetDocumentEffectivePrecedenceOrders401 | GroupsControllerGetDocumentEffectivePrecedenceOrders403 | GroupsControllerGetDocumentEffectivePrecedenceOrders404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? groupsControllerGetDocumentEffectivePrecedenceOrdersQueryKey(documentId, params);
  const query = useQuery({
    ...groupsControllerGetDocumentEffectivePrecedenceOrdersQueryOptions(documentId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GroupsControllerGetDocumentEffectivePrecedenceOrders401 | GroupsControllerGetDocumentEffectivePrecedenceOrders403 | GroupsControllerGetDocumentEffectivePrecedenceOrders404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}